"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigBase = exports.ConfigBaseImplementation = exports.configBase = void 0;
var privateConfig;
var setConfig = function (config) {
    privateConfig = config;
};
var getConfig = function () { return privateConfig; };
exports.configBase = {
    setConfig: setConfig,
    getConfig: getConfig,
};
var ConfigBaseImplementation = /** @class */ (function () {
    function ConfigBaseImplementation() {
        return exports.configBase;
    }
    return ConfigBaseImplementation;
}());
exports.ConfigBaseImplementation = ConfigBaseImplementation;
exports.ConfigBase = new ConfigBaseImplementation();
exports.default = exports.ConfigBase;
